






















































import { Component, InjectReactive, Prop, PropSync, Watch } from 'vue-property-decorator';
import { ConsentCondition, ConsentConditionType, EntityStatus, Product } from '@/api';
import WaterConsentConditionModalTitle from '@/components/display/water-consents/conditions/water-consent-condition-modal-title.vue';
import WaterConsentConditionType, {
	ConditionRollingPeriod,
} from '@/components/display/water-consents/conditions/water-consent-condition-type';

@Component({
	components: { WaterConsentConditionModalTitle },
})
export default class WaterConsentConditionTypeRollingPeriod extends WaterConsentConditionType<
	ConditionRollingPeriod
> {
	@InjectReactive('waterProduct')
	public product!: Product;

	@Prop({ required: true })
	public consentConditionType!: ConsentConditionType;

	@PropSync('formValid')
	public _formValid!: boolean;

	@Prop()
	public consentCondition!: ConsentCondition | null;

	protected volumeValue: number = 0;
	protected volumeUnit: string | null = 'litres';

	protected periodValue: number = 0;
	protected periodUnit: string | null = null;
	protected periodUnitOptions: { text: string; value: any; disabled?: boolean }[] = [
		{ text: 'Select time period unit...', value: null, disabled: true },
		{ text: 'Hours', value: 'hour' },
		{ text: 'Days', value: 'day' },
		{ text: 'Weeks', value: 'week' },
		{ text: 'Months', value: 'month' },
	];

	protected waterMeterIds: number[] = [];
	protected waterMeterOptions: { text: string; value: any }[] = [];

	public mounted() {
		this.watchProduct();
	}

	@Watch('product', { deep: true })
	public watchProduct() {
		this.waterMeterOptions =
			this.product?.watermeters
				?.filter(
					waterMeter =>
						![EntityStatus.Removed, EntityStatus.Cancelled].includes(
							waterMeter?.status ?? EntityStatus.Live,
						),
				)
				?.map(waterMeter => ({
					text: waterMeter.name,
					value: waterMeter.id,
				}))
				?.sort((a, b) => (a.value ?? 0) - (b.value ?? 0)) ?? [];

		this.volumeValue = (<any>this.consentCondition?.parameters)?.volumeValue ?? 0;
		this.volumeUnit = (<any>this.consentCondition?.parameters)?.volumeUnit ?? 'litres';
		this.periodValue = (<any>this.consentCondition?.parameters)?.periodValue ?? 0;
		this.periodUnit = (<any>this.consentCondition?.parameters)?.periodUnit ?? null;
		this.waterMeterIds = (<any>this.consentCondition?.parameters)?.waterMeterIds ?? [];

		this.validate();
	}

	@Watch('volumeValue')
	@Watch('volumeUnit')
	@Watch('periodValue')
	@Watch('periodUnit')
	@Watch('waterMeterIds')
	protected validate(): void {
		this._formValid =
			this.volumeValue > 0 &&
			this.volumeValue.toString().length > 0 &&
			this.periodValue > 0 &&
			this.periodValue.toString().length > 0 &&
			this.periodUnit != null &&
			this.waterMeterIds.length > 0;
	}

	public getParameters(): ConditionRollingPeriod {
		return {
			volumeValue: this.volumeValue,
			volumeUnit: this.volumeUnit ?? undefined,
			periodValue: this.periodValue,
			periodUnit: this.periodUnit ?? undefined,
			waterMeterIds: this.waterMeterIds,
		};
	}
}
